const api = {
  url: "https://test.healthprofile.digital:8080/",
};

export default api;
